import { ActivityId } from '@gyym/sdk'
import { Button, FacilityCard, Link, RankedFacilityCardProps } from '@gyym/ui'
import React from 'react'

import { ButtonContainer, Container } from './styles'

const getRankingName = (name: string): React.ReactNode | string => {
  switch (name) {
    case '暗闇フィットネス':
      return (
        <>
          暗闇フィットネス
          <br />
          ランキング
        </>
      )
    case 'サーフエクササイズ':
      return (
        <>
          サーフエクササイズ
          <br />
          ランキング
        </>
      )
    case 'サーキットトレーニング':
      return (
        <>
          サーキットトレーニング
          <br />
          ランキング
        </>
      )
    case 'パーソナルトレーニング':
      return (
        <>
          パーソナルトレーニング
          <br />
          ランキング
        </>
      )
    case 'エステ・セルフエステ':
      return (
        <>
          エステ・セルフエステ
          <br />
          ランキング
        </>
      )
    default:
      return `${name}ランキング`
  }
}

export interface ActivityRankingSlideProps
  extends Omit<RankedFacilityCardProps, 'variant'> {
  activityId: ActivityId
}

export const ActivityRankingSlide = ({
  activityId,
  activityRankingName,
  ...cardProps
}: ActivityRankingSlideProps) => {
  return (
    <Container>
      <FacilityCard
        variant="ranked"
        {...cardProps}
        activityRankingName={activityRankingName}
      />
      <ButtonContainer>
        <Button
          className="w-[210px] text-center md:h-[56px] md:w-full"
          variant="primary-outlined"
          asChild
        >
          <Link href={`/rankings/${activityId}`}>
            {activityRankingName ? getRankingName(activityRankingName) : ''}
          </Link>
        </Button>
      </ButtonContainer>
    </Container>
  )
}
